/* SPACELY — Transmission Loader (white / static-breach / GEMINI 8 promo)
   Injected on the home page only (theme.liquid gates the <script> with template=='index').
   Palette: White #FFFFFF / Deep Space Black #000000 / Orbit Red #D60000. IBM Plex Mono.
   Sound synthesised via Web Audio (silent until a user gesture; muted under reduced-motion). */
(function(){
  try{
    var path = location.pathname.replace(/\/+$/,'') || '/';
    if(path !== '/') return; /* home only safety guard */
    if(document.getElementById('tw-loader')) return;

    var fonts=document.createElement('link');
    fonts.rel='stylesheet';
    fonts.href='https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;700&display=swap';
    document.head.appendChild(fonts);

    var css=''+
'#tw-loader{position:fixed;inset:0;z-index:99999;background:#FFFFFF;display:flex;align-items:center;justify-content:center;opacity:1;transition:opacity .4s ease;cursor:pointer;overflow:hidden;font-family:"IBM Plex Mono","SFMono-Regular",Menlo,Consolas,monospace;}'+
'#tw-loader.tw-done{opacity:0;pointer-events:none;}'+
'#tw-loader.tw-flick{animation:tw-flick .2s steps(2) 2;}'+
'@keyframes tw-flick{0%{background:#fff}50%{background:#f0f0f0}100%{background:#fff}}'+
'#tw-static{position:absolute;inset:0;z-index:1;width:100%;height:100%;opacity:.05;mix-blend-mode:multiply;pointer-events:none;image-rendering:pixelated;}'+
'#tw-loader:before{content:"";position:absolute;inset:0;z-index:2;pointer-events:none;background:repeating-linear-gradient(to bottom,rgba(0,0,0,.045) 0px,rgba(0,0,0,.045) 1px,transparent 2px,transparent 4px);}'+
'#tw-tear{position:absolute;inset:0;z-index:2;opacity:0;pointer-events:none;}'+
'#tw-tear.tw-on{opacity:1;animation:tw-tear .1s steps(2) infinite;}'+
'#tw-tear span{position:absolute;left:0;right:0;height:8px;background:#D60000;mix-blend-mode:multiply;}'+
'@keyframes tw-tear{0%{transform:translateX(0)}50%{transform:translateX(10px)}100%{transform:translateX(-8px)}}'+
'#tw-wrap{position:relative;z-index:2;width:min(90vw,640px);display:flex;flex-direction:column;align-items:flex-start;padding:clamp(16px,4vw,40px);}'+
'#tw-term{font-size:clamp(11px,1.7vw,15px);line-height:1.6;letter-spacing:.04em;white-space:pre-wrap;margin:0 0 1.4rem;max-width:42ch;color:#000;}'+
'#tw-reveal{width:100%;opacity:0;transition:opacity .3s ease;}'+
'#tw-reveal.tw-show{opacity:1;}'+
'.tw-mark{font-weight:700;color:#000;font-size:clamp(2rem,11vw,5.5rem);letter-spacing:.14em;line-height:.98;text-transform:uppercase;position:relative;margin:0 0 .4rem;text-shadow:-2px 0 #D60000,2px 0 rgba(0,0,0,.55);}'+
'.tw-drop{font-weight:700;color:#D60000;font-size:clamp(1rem,3.4vw,1.6rem);letter-spacing:.2em;text-transform:uppercase;margin:.2rem 0;}'+
'.tw-meta{font-weight:400;color:#000;font-size:clamp(.72rem,2.3vw,1rem);letter-spacing:.26em;text-transform:uppercase;margin:.12rem 0;}'+
'#tw-count{color:#D60000;font-weight:700;letter-spacing:.16em;}'+
'.tw-enter{color:#D60000;font-weight:700;}'+
'#tw-loader.tw-breach #tw-wrap{animation:tw-shake .26s steps(2) 3;}'+
'#tw-loader.tw-breach #tw-term{text-shadow:-2px 0 #D60000,2px 0 rgba(0,0,0,.6);color:#000;}'+
'@keyframes tw-shake{0%{transform:translate(0,0)}25%{transform:translate(-4px,1px)}50%{transform:translate(4px,-2px)}75%{transform:translate(-2px,2px)}100%{transform:translate(0,0)}}'+
'.tw-mark.tw-split{animation:tw-mshake .18s steps(2) infinite;}'+
'@keyframes tw-mshake{0%{transform:translate(0,0)}50%{transform:translate(3px,-1px)}100%{transform:translate(-3px,1px)}}'+
'@media (prefers-reduced-motion: reduce){#tw-loader.tw-flick,#tw-loader.tw-breach #tw-wrap,#tw-tear.tw-on,.tw-mark.tw-split{animation:none;}}';
    var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);

    function build(){
      var loader=document.createElement('div');
      loader.id='tw-loader'; loader.setAttribute('role','status'); loader.setAttribute('aria-label','Loading Spacely');
      loader.innerHTML=
        '<canvas id="tw-static"></canvas>'+
        '<div id="tw-tear"><span style="top:20%"></span><span style="top:46%"></span><span style="top:69%"></span><span style="top:86%"></span></div>'+
        '<div id="tw-wrap"><pre id="tw-term"></pre><div id="tw-reveal"></div></div>';
      document.body.appendChild(loader);
      run(loader);
    }

    function run(loader){
      var term=loader.querySelector('#tw-term');
      var tear=loader.querySelector('#tw-tear');
      var reveal=loader.querySelector('#tw-reveal');
      var canvas=loader.querySelector('#tw-static');

      var DROP_TS=Date.UTC(2026,5,26,8,30,0);      /* Fri 26 Jun 6:30PM AEST */
      var CAMPAIGN_END=Date.UTC(2026,5,28,14,0,0);  /* end Sun 28 Jun AEST */
      var COLLECTION='/collections/gemini-8-night-shift';
      var now=Date.now();
      var phase = now>=CAMPAIGN_END ? 'evergreen' : (now>=DROP_TS ? 'live' : 'pre');
      var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var alive=true;

      var ctx=canvas.getContext('2d'), NW=180, NH=110; canvas.width=NW; canvas.height=NH;
      var baseOpacity=0.05, raf, frame=0;
      function drawStatic(){ if(!alive) return; frame++; if(frame%2===0){ var img=ctx.createImageData(NW,NH), d=img.data; for(var i=0;i<d.length;i+=4){ var v=Math.random()*255; d[i]=d[i+1]=d[i+2]=v; d[i+3]=255; } ctx.putImageData(img,0,0); } raf=requestAnimationFrame(drawStatic); }
      if(!reduce){ drawStatic(); } else { canvas.style.display='none'; }
      function staticLevel(v){ canvas.style.opacity=v; }

      var actx=null;
      function ac(){ if(reduce) return null; try{ if(!actx) actx=new (window.AudioContext||window.webkitAudioContext)(); if(actx.state==='suspended') actx.resume(); return actx; }catch(e){ return null; } }
      function blip(f,d,t,v){ var a=ac(); if(!a) return; var o=a.createOscillator(),g=a.createGain(); o.type=t||'square'; o.frequency.value=f; var tm=a.currentTime; g.gain.setValueAtTime(v||0.035,tm); g.gain.exponentialRampToValueAtTime(0.0001,tm+d); o.connect(g); g.connect(a.destination); o.start(tm); o.stop(tm+d); }
      function burst(d,v){ var a=ac(); if(!a) return; var n=Math.floor(a.sampleRate*d), buf=a.createBuffer(1,n,a.sampleRate), da=buf.getChannelData(0); for(var i=0;i<n;i++) da[i]=Math.random()*2-1; var s=a.createBufferSource(); s.buffer=buf; var f=a.createBiquadFilter(); f.type='bandpass'; f.frequency.value=1100; var g=a.createGain(); var tm=a.currentTime; g.gain.setValueAtTime(v||0.05,tm); g.gain.exponentialRampToValueAtTime(0.0001,tm+d); s.connect(f); f.connect(g); g.connect(a.destination); s.start(tm); s.stop(tm+d); }
      function lockTone(){ blip(220,0.12,'triangle',0.05); setTimeout(function(){ blip(440,0.22,'triangle',0.05); },110); }
      ['pointerdown','keydown','touchstart'].forEach(function(ev){ window.addEventListener(ev,function u(){ ac(); window.removeEventListener(ev,u); },{once:true}); });
      ac();

      var BOOT, breachAt;
      if(phase==='pre'){
        BOOT=['SPACELY//TX SYSTEM  v8.0','> establishing uplink ........ OK','> decrypting night signal ....','░▒▓ SIGNAL INTERCEPTED ▓▒░','! UNAUTHORISED ACCESS DETECTED','> override ███▓▒░ breaching ░▒▓','> channel locked :: GEMINI 8'];
        breachAt=[3,4,5];
      } else if(phase==='live'){
        BOOT=['SPACELY//TX SYSTEM  v8.0','> establishing uplink ........ OK','> uplink restored ............ OK','> channel OPEN :: GEMINI 8']; breachAt=[];
      } else {
        BOOT=['SPACELY//TX SYSTEM  v8.0','> establishing uplink ........ OK','> channel idle']; breachAt=[];
      }

      function buildReveal(){
        if(phase==='pre'){
          reveal.innerHTML='<div class="tw-mark" id="tw-m">SPACELY</div><div class="tw-drop">GEMINI 8 — NIGHT SHIFT</div><div class="tw-meta">INBOUND // 26.06.26 // 6:30PM AEST</div><div class="tw-meta"><span id="tw-count">--d : --h : --m : --s</span></div>';
        } else if(phase==='live'){
          reveal.innerHTML='<div class="tw-mark" id="tw-m">SPACELY</div><div class="tw-drop">GEMINI 8 — NIGHT SHIFT</div><div class="tw-meta tw-enter">LIVE NOW // 26.06.26</div><div class="tw-meta">tap to enter ▸</div>';
        } else {
          reveal.innerHTML='<div class="tw-mark" id="tw-m">SPACELY</div><div class="tw-meta">03:00AM. YOU FOUND THE FRONT DOOR.</div>';
        }
      }
      function startCount(){
        var el=loader.querySelector('#tw-count'); if(!el) return;
        function pad(n){ return (n<10?'0':'')+n; }
        function tick(){ var dd=DROP_TS-Date.now(); if(dd<=0){ el.textContent='SIGNAL OPEN'; return; } var s=Math.floor(dd/1000), days=Math.floor(s/86400), h=Math.floor((s%86400)/3600), m=Math.floor((s%3600)/60), ss=s%60; el.textContent=pad(days)+'d : '+pad(h)+'h : '+pad(m)+'m : '+pad(ss)+'s'; }
        tick(); setInterval(tick,1000);
      }
      function showReveal(){
        buildReveal(); reveal.classList.add('tw-show'); lockTone();
        var m=loader.querySelector('#tw-m');
        if(m && !reduce){ m.classList.add('tw-split'); setTimeout(function(){ m.classList.remove('tw-split'); },500); }
        if(phase==='pre') startCount();
        setTimeout(dismiss, phase==='live'?2200:1500);
      }
      function dismiss(){ alive=false; if(raf) cancelAnimationFrame(raf); loader.classList.add('tw-done'); setTimeout(function(){ if(loader.parentNode) loader.parentNode.removeChild(loader); },450); }
      loader.addEventListener('click',function(){ if(phase==='live'){ window.location.href=COLLECTION; return; } dismiss(); });

      var li=0;
      function typeLine(){
        if(li>=BOOT.length){ setTimeout(showReveal,160); return; }
        var line=BOOT[li], breach=breachAt.indexOf(li)!==-1, ci=0;
        if(breach && !reduce){ loader.classList.add('tw-breach','tw-flick'); tear.classList.add('tw-on'); staticLevel(0.28); burst(0.34,0.05); blip(90,0.25,'sawtooth',0.04); setTimeout(function(){ loader.classList.remove('tw-flick'); },400); }
        var typer=setInterval(function(){
          term.textContent=BOOT.slice(0,li).join('\n')+(li?'\n':'')+line.slice(0,ci)+'<'; ci++;
          if(ci%2===0) blip(breach?180:660,0.02,'square',0.02);
          if(ci>line.length){ clearInterval(typer); term.textContent=BOOT.slice(0,li+1).join('\n');
            if(breach && !reduce){ setTimeout(function(){ loader.classList.remove('tw-breach'); tear.classList.remove('tw-on'); staticLevel(baseOpacity); },120); }
            li++; setTimeout(typeLine, breach?90:60);
          }
        }, breach?12:9);
      }
      typeLine();
      setTimeout(dismiss, 4000);
    }

    if(document.body){ build(); }
    else { document.addEventListener('DOMContentLoaded', build); }
  }catch(e){ /* fail silent — never block the storefront */ }
})();
